import i18n from "i18next";
import {Card} from "@/Components/Card";
import GeneralPurchaseModal from "@/Pages/BuyFlow/GeneralPurchaseModal";
import {usePage} from "@inertiajs/inertia-react";
import {navigateToURL} from "@/Utilities/Util";

export default function MiscHelpCards({state, dispatch, dataTestid}) {
    let auth = usePage().props.auth;
    const features = usePage().props.features;
    const salesloftURL = usePage().props.salesloft_url;
    const isPlatformUnity = auth.current_organization.is_platform_unity;

    return (
        <div className="row">
            <Card dataTestid={'explore-'+ dataTestid} className="help-ministry-card misc-card col">
                <div>
                    <div className="misc-card-svg"><img className="help-ministry-svg" src="/images/help-your-ministry.svg"/></div>
                    <div className="misc-card-header">{i18n.t("admin-account-overview.help-ministry-header")}</div>
                    <span className="misc-card-desc">{i18n.t("admin-account-overview.help-ministry-body")}</span>
                    {isPlatformUnity &&
                        <a data-testid={'explore_unity-link-'+dataTestid} href="https://help.myamplify.io/hc/en-us"
                           target="_blank"
                           className="misc-card-action"
                        >
                            {i18n.t("admin-account-overview.explore")}
                        </a>
                    }
                    {!isPlatformUnity &&
                        <a data-testid={'explore_catholic_unity-link-'+ dataTestid} href="https://support.parishsoft.com/hc/en-us"
                           target="_blank"
                           className="misc-card-action"
                        >
                            {i18n.t("admin-account-overview.explore")}
                        </a>
                    }
                </div>
            </Card>
            {features['checkout'] && <Card dataTestid={'upgrade-'+ dataTestid} className="upgrade-bundle-card misc-card col">
                <div>
                    <div className="misc-card-svg"><img src="/images/upgrade-your-bundle.svg"/></div>
                    <div className="misc-card-header">{i18n.t("admin-account-overview.upgrade-bundle-header")}</div>
                    <span className="misc-card-desc">{i18n.t("admin-account-overview.upgrade-bundle-body")}</span>
                    <span data-testid={'upgrade-link'+ dataTestid} className="misc-card-action"
                          onClick={() => { !salesloftURL ?
                              dispatch({ type: "showCheckoutModal", payload: { showCheckoutModal: true }}): navigateToURL(salesloftURL)
                          }}>
                        {i18n.t("admin-account-overview.upgrade")}
                    </span>
                </div>
            </Card>}
            <Card dataTestid={'need-help-'+ dataTestid} className="need-help-card misc-card col">
                <div>
                    <div className="misc-card-svg"><img src="/images/need-help.svg"/></div>
                    <div className="misc-card-header">{i18n.t("admin-account-overview.need-help-header")}</div>
                    <span className="misc-card-desc">{i18n.t("admin-account-overview.need-help-body")}</span>
                    {isPlatformUnity &&
                        <a data-testid={'need-help-unity-link-'+dataTestid} href="https://help.myamplify.io/hc/en-us"
                           target="_blank"
                           className="misc-card-action"
                        >
                            {i18n.t("admin-account-overview.need-help")}
                        </a>
                    }
                    {!isPlatformUnity &&
                        <a data-testid={'need-help-unity-link-'+dataTestid} href="https://support.parishsoft.com/hc/en-us"
                           target="_blank"
                           className="misc-card-action"
                        >
                            {i18n.t("admin-account-overview.need-help")}
                        </a>
                    }
                </div>
            </Card>
            { state.showCheckoutModal && <GeneralPurchaseModal state={state} dispatch={dispatch}/> }
        </div>
    )
}
